import React from 'react';
import EditUserState from './editUserState/EditUserState';
import Form from './components/Form/Form';
import ModalWindows from './components/ModalWindows/ModalWindows';

const EditUserPage: React.FC = () => {
	return (
		<EditUserState>
			<Form />
			<ModalWindows />
		</EditUserState>
	);
};

export default EditUserPage;
